import { render } from "./CorespondentaUseri.vue?vue&type=template&id=f5ea6778"
import script from "./CorespondentaUseri.vue?vue&type=script&lang=js"
export * from "./CorespondentaUseri.vue?vue&type=script&lang=js"

import "./CorespondentaUseri.vue?vue&type=style&index=0&id=f5ea6778&lang=css"

import exportComponent from "C:\\Development\\pocu-sihlea\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__